import type { UserInfoDetail } from "@ifa/utils";
import CustomButton from "../../../components/CustomButton";
import phoneIcon from "../../../assets/img/phone.png";
import emailIcon from "../../../assets/img/email.png";
import accountIcon from "../../../assets/img/account.png";
import passwordIcon from "../../../assets/img/password.png";
import styles from "../Profile.module.css";

interface AccountInfoCardProps {
  userInfo: UserInfoDetail | null;
  onChangePassword: () => void;
  onLogout: () => void;
}

export function AccountInfoCard({ userInfo, onChangePassword, onLogout }: AccountInfoCardProps) {
  // 格式化手机号
  const formatPhone = () => {
    if (!userInfo?.phone) return "未設定";
    if (userInfo.areaCode) {
      return `+${userInfo.areaCode} ${userInfo.phone}`;
    }
    return userInfo.phone;
  };

  return (
    <div className={styles.infoCard}>
      <div className={styles.cardTitle}>帳戶資訊</div>
      <div className={styles.cardContent}>
        <div className={styles.infoItem}>
          <div className={styles.infoIcon}>
            <img src={phoneIcon} alt="phone" />
          </div>
          <div className={styles.infoContent}>
            <div className={styles.infoLabel}>香港手提電話號碼</div>
            <div className={styles.infoValue}>{formatPhone()}</div>
          </div>
        </div>

        <div className={styles.infoItem}>
          <div className={styles.infoIcon}>
            <img src={emailIcon} alt="email" />
          </div>
          <div className={styles.infoContent}>
            <div className={styles.infoLabel}>電郵</div>
            <div className={styles.infoValue}>{userInfo?.workEmail || "未設定"}</div>
          </div>
        </div>

        <div className={styles.infoItem}>
          <div className={styles.infoIcon}>
            <img src={accountIcon} alt="account" />
          </div>
          <div className={styles.infoContent}>
            <div className={styles.infoLabel}>登入帳號</div>
            <div className={styles.infoValue}>{userInfo?.account || userInfo?.phone || "未設定"}</div>
          </div>
        </div>

        <div className={styles.infoItem}>
          <div className={styles.infoIcon}>
            <img src={passwordIcon} alt="password" />
          </div>
          <div className={styles.infoContent}>
            <div className={styles.infoLabel}>登入密碼</div>
            <div className={styles.infoValue}>********</div>
          </div>
          <CustomButton bgColor="#00C7B6" className={styles.changePasswordBtn} onClick={onChangePassword}>
            修改密碼
          </CustomButton>
        </div>

        {/* 退出登录按钮 */}
        <div className={styles.logoutItem}>
          <CustomButton bgColor="#fff" color="#ff4d4f" block={true} height="44px" onClick={onLogout} className={styles.logoutBtn} style={{ border: "1px solid #ff4d4f" }}>
            登出
          </CustomButton>
        </div>
      </div>
    </div>
  );
}
